import { render, staticRenderFns } from "./invite-list.vue?vue&type=template&id=11144b63&"
import script from "./invite-list.vue?vue&type=script&lang=js&"
export * from "./invite-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports